
const square = {
    root: {
        borderRadius: '.375rem',

    },
    track: {
        borderRadius: '.375rem',
    },
    thumb: {
        borderRadius: '.25rem',
    },
    label: {
    }
};

export default {
    defaultProps: {
        size: 'md',
        withThumbIndicator: false,
    },
    styles: (_, { variant }) => {
        if (variant === 'square') {
            return square;
        }
        return {};
    },
};
